// extracted by mini-css-extract-plugin
export default {"center":"Signup_center__J1TBh","SignUp":"Signup_SignUp__8JtIr","login":"Signup_login__OwZ4o"};